<template>
  <div id="preview" class="preview" v-if="data" style="font-family: Arial, KaiTi">
    <div class="" :style="[allStudentShow ? { maxHeight: 'none' } : { maxHeight: '145px' }, { overflow: 'hidden' }]">
      <span style="font-weight: bold; font-size: 14px">{{ lang('Showing To') }}</span>
      <K2Row v-if="data.studentList.length > 0" :styles="{ flexWrap: 'wrap' }">
        <K2Row
          justify_content="center"
          align="center"
          v-for="(student, i) in data.studentList"
          :key="student.PostTagUserID + i"
          class="box purple rounded-pill"
          style="padding: 0 2px"
        >
          <span style="font-size: 14px; color: #7a81b9">{{ student.StudentName || student.First_Name }}</span>
        </K2Row>
      </K2Row>
    </div>
    <div v-for="(item, i) of data.postFiles" :key="i" style="margin: 10px 0 0">
      <video
        v-if="
          item.PostItemFileExt === '.MOV' ||
          item.PostItemFileExt === '.mov' ||
          item.PostItemFileExt === '.mp4' ||
          item.PostItemFileExt === '.avi' ||
          item.type === 'video/mp4' ||
          item.type === 'video/quicktime' ||
          item.type === 'video/avi'
        "
        class="media-file-video video preview"
        style="max-width: 100%; height: 100%"
        controls
        :src="item.oriFilePath"
        :type="item.type || item.PostItemFileType"
        controlsList="nodownload"
      ></video>
      <div class="media-file-pdf" v-else-if="item.type === 'application/pdf' || item.PostItemFileType === 'application/pdf'">
        <pdf
          v-for="i in item.numPages"
          :key="i"
          :page="i"
          class="pdf preview"
          :src="item.oriFilePath"
          style="max-width: 100%; height: 400px; overflow: auto"
        ></pdf>
      </div>

      <img v-else width="300px" :src="item.oriFilePath" />
    </div>
    <div>
      <K2Text bold="true" style="font-size: 14px">{{ lang('Content') }}:</K2Text>
      <span v-html="data.PostUpdDtlDescription" style="font-size: 14px" />
      <div class="">
        <span style="font-size: 14px; font-weight: bold">{{ lang('Tags') }}:</span>
        <K2Row class="flex-wrap" v-if="data && data.PostKeyTags">
          <K2Row
            justify_content="center"
            align="center"
            v-for="tag in data.PostKeyTags"
            :key="tag.PostKeyTagPostID"
            class="box purple rounded-pill"
            style="padding: 0 2px"
          >
            <span style="font-size: 14px; color: #7a81b9">{{ tag.PostKeyTagValue }}</span>
          </K2Row>
        </K2Row>
      </div>

      <div class="me-2">
        <K2Text style="font-size: 14px" bold="true" v-if="data && data.PostIsUpdated">{{ lang('Modified on') }}:</K2Text>
        <K2Text style="font-size: 14px" bold="true" v-else>{{ lang('Created On') }}:</K2Text>
        <K2Text style="font-size: 14px" :color="uiVariable.color.purple">
          {{ moment(data.PostCreatedDate).format('DD/MM/YYYY [&nbsp;] HH:mm') }}
        </K2Text>
      </div>
      <div>
        <K2Text style="font-size: 14px" bold="true">{{ lang('Post Type') }}:</K2Text>
        <K2Text style="font-size: 14px" :color="uiVariable.color.purple"> {{ data.PostType }}</K2Text>
      </div>

      <div class="box purple p-3 rounded-3 mt-3" style="width: 500px" v-if="data && data.PostLearningMoments.length > 0">
        <!--        {{passdevelopmentgoals}}-->
        <K2Text style="font-size: 14px" bold="true" :color="uiVariable.color.purple">{{ lang('Learning Goals') }} ({{ lang('Indicator') }}) </K2Text>
        <div>
          <div v-for="item of data.PostLearningMoments" :key="item.PostUpLMID" class="mb-2">
            <K2Text style="font-size: 14px">{{ item.PostUpLMIndicator }}</K2Text>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uiVariable from '../../../../config/uiVariable'
import K2Carousel from '../../../../uiComponents/k2Carousel/k2Carousel'
import K2Text from '../../../../uiComponents/k2Text/k2Text'
import moment from 'moment'
import K2Row from '../../../../uiComponents/k2Row/k2Row'
import K2Button from '../../../../uiComponents/k2Button/k2Button'
import { lang } from '../../../../locale'
import pdf from 'vue-pdf'

export default {
  name: 'activityPreviewforPrint',
  props: ['printPreview'],
  components: { K2Button, K2Row, K2Text, K2Carousel, pdf },
  data() {
    return {
      uiVariable: uiVariable,
      moment: moment,
      allStudentShow: false,
      data: null,
    }
  },
  watch: {
    printPreview: function (value) {
      if (value) {
        this.data = value
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    lang,
    onSlideStart(slide) {
      this.sliding = true
    },
    handleStudentShow() {
      this.allStudentShow = !this.allStudentShow
    },
  },
}
</script>
